import { FC, useEffect, useState } from 'react';
import { LoadingIcon } from 'assets/svg';
import { Loader } from 'components/Loader/Loader';
import { LOADER_SLIDES_TEXT, LOADING_SLIDE_TIMEOUT_MS } from 'constants/index';

import * as S from './ResultsLoader.styled';

import loader from './Loader.gif';


import animationData from './analysisLoop.json';

interface IResultsLoaderProps {}

export const ResultsLoader: FC<IResultsLoaderProps> = ({}) => {
  const [loadingText, setLoadingText] = useState(LOADER_SLIDES_TEXT[0]);

  useEffect(() => {
    let currentIndex = 0;
    const interval = setInterval(() => {
      currentIndex += 1;
      if (currentIndex < LOADER_SLIDES_TEXT.length) {
        setLoadingText(LOADER_SLIDES_TEXT[currentIndex]);
      } else {
        clearInterval(interval);
      }
    }, LOADING_SLIDE_TIMEOUT_MS);

    return () => clearInterval(interval);
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  const LoaderStyle = {
    margin: '0'
  };

  return (
    <S.Wrapper>
      {/* <S.Loader src={loader}/> */}
      <S.Loader 
        options={defaultOptions}
        height={400}
        width={400}
        style={LoaderStyle}
        isClickToPauseDisabled={true}
      />
      <S.Description>
        <S.LoadingStep>{loadingText}</S.LoadingStep>
        <S.LoadingDescription>Our AI pulled these questions from our website. Now, give it a sec — it’s summarizing your answers.</S.LoadingDescription>
      </S.Description>
    </S.Wrapper>
  );
};
